import { Typography } from '@e3dc-react/shell/Elements/Typography'
import React from 'react'

interface BatteryStatusItemValuesProps {
  values: { [key: string]: Array<string | number> }
  valueKeys: { [key: string]: { highVoltage: string; lowVoltage: string } }
  moduleCount: number
  isLowVoltageBattery: boolean
}

/**
 * Values to be displayed in a battery status item
 */
const BatteryStatusItemValues: React.FC<BatteryStatusItemValuesProps> = ({ values, valueKeys, moduleCount, isLowVoltageBattery }) => {
  const valuesToPrint: React.ReactElement[] = []

  Object.keys(values).forEach(key => {
    for (let i = 0; i < moduleCount; i++) {
      const value = values[key][i]
      const translationKey = isLowVoltageBattery ? valueKeys[key].lowVoltage : valueKeys[key].highVoltage
      valuesToPrint.push(
        <Typography key={key} variant="subtitle2" values={{ [key]: value, module: i + 1 }} component={'span'}>
          {translationKey}
        </Typography>
      )
    }
  })

  return valuesToPrint
}

export default BatteryStatusItemValues
